import { FilterAlt } from "@mui/icons-material"
import { Button } from "@mui/material/index"

interface CBAdvancedFiltersButtonProps {
    description: string,
    onClick: () => void
}

const CBAdvancedFiltersButton = ({
    description,
    onClick

}: CBAdvancedFiltersButtonProps) => {

    return (
        <Button 
            variant={"text"}
            color={"accent"}
            startIcon={<FilterAlt/>}
            onClick={onClick}
        >
            {description}
        </Button>
    )
}

export default CBAdvancedFiltersButton;